@for (section of model.sections; track section) {
    <table class="table table-sm table-striped">
        <!-- Only display the header line if it contains something or if we have multiple sections that need a visual separator -->
        @if (section.header.length > 0 && model.sections.length > 1) {
            <thead>
                <tr>
                    <th class="section-header" colspan="2">{{ section.header }}</th>
                </tr>
            </thead>
        }
        <tbody>
            @for (entry of section.entries; track entry) {
                <tr>
                    <th class="contract-label">{{ entry.label }}</th>
                    <td class="contract-value">{{ entry.value | formatSapValue }}</td>
                </tr>
            }
        </tbody>
    </table>
}
